'use client';

import { classNames } from "../../../utils/styles/classNames.js";
import { transition, spaceVertical, spaceHorizontalWithoutLabel, spaceHorizontalWithoutIcon, spaceHorizontal, gaps, full, contentHidden, content } from "../Button.css.js";
function getButtonContentClassNames(p) {
  return classNames(
    content,
    (p.isLoading || p.isSuccess) && contentHidden,
    p.fullWidth && full,
    !p.isLabelHidden && gaps[p.horizontalSpaceType][p.size],
    !p.isLabelHidden && !!p.Icon && spaceHorizontal[p.horizontalSpaceType][p.iconPosition][p.size],
    !p.isLabelHidden && !p.Icon && spaceHorizontalWithoutIcon[p.horizontalSpaceType][p.size],
    p.isLabelHidden && spaceHorizontalWithoutLabel[p.horizontalSpaceType][p.size],
    spaceVertical[p.spaceType][p.size],
    transition[p.spaceType]
  );
}
export {
  getButtonContentClassNames
};
